import http from '@/plugins/http';
import reportError from '@/utils/reportError';

// When the request succeeds
const success = (response, successCallback) => {
  successCallback(response);
};

// When the request fails
const failed = () => {
};

export default (job, userJobId, score, comment, successCallback, token, fromUserId) => {
  const feedback = {};
  feedback.score = score;
  if (comment !== '') {
    feedback.feedback = comment;
  }
  const params = { feedback };
  if (token) {
    params.token = token;
  }

  if (fromUserId) {
    params.fromUserId = fromUserId;
  }
  http.post(`/customer/me/jobs/${job.id}/students/${userJobId}/feedback`, params)
    .then((response) => {
      success(response.data, successCallback);
    })
    .catch((error) => {
      reportError(error, 'error when trying to post feedback on job');
      failed(error);
    });
};
